import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TUserClientContact, TUserClientContactPayloadCreate, TUserClientContactResponse, adaptUserClientContactFromResponse, adaptUserClientContactToRequest } from '../../types';
import { useAppSelector } from '../../hooks';
import { BACKEND_USER_CLIENT } from '../../backend-paths';


export const userClientContactCreateApi = createAsyncThunk(
	`POST/${BACKEND_USER_CLIENT}/:client_id/contacts`,
	(payload: TUserClientContactPayloadCreate, thunkApi) => {
		const { clientId, data } = payload;
		const path = `${BACKEND_USER_CLIENT}/${clientId}/contacts`;

		const dataRequest = adaptUserClientContactToRequest(data);

		return HttpService.post<TUserClientContactResponse>(path, dataRequest).then(result => {
			return adaptUserClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item: TUserClientContact | undefined,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const userClientContactCreateSlice = createSlice({
	name: 'userClientContactCreateSlice',
	initialState,
	reducers: {
		clearUserClientContactCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[userClientContactCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[userClientContactCreateApi.fulfilled.type]: (state, action: PayloadAction<TUserClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[userClientContactCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useUserClientContactCreateSelector = () => useAppSelector(state => state[userClientContactCreateSlice.name]);

export const { clearUserClientContactCreate } = userClientContactCreateSlice.actions;
